import { MAX_CONTENT_WIDTH } from 'appConstants';

export const styles = {
  containerMobile: {
    width: MAX_CONTENT_WIDTH,
    ml: 'auto',
    mr: 'auto',
  },
};
